import { TFunction } from 'react-i18next'

export const getTranslatedStates = (t: TFunction<'translation', undefined>) => {
  return {
    CA: {
      AB: t('state_ca_ab', 'Alberta'),
      BC: t('state_ca_bc', 'British Columbia'),
      MB: t('state_ca_mb', 'Manitoba'),
      NB: t('state_ca_nb', 'New Brunswick'),
      NL: t('state_ca_nl', 'Newfoundland and Labrador'),
      NS: t('state_ca_ns', 'Nova Scotia'),
      NT: t('state_ca_nt', 'Northwest Territories'),
      NU: t('state_ca_nu', 'Nunavut'),
      ON: t('state_ca_on', 'Ontario'),
      PE: t('state_ca_pe', 'Prince Edward Island'),
      QC: t('state_ca_qc', 'Quebec'),
      SK: t('state_ca_sk', 'Saskatchewan'),
      YT: t('state_ca_yt', 'Yukon')
    },
    MX: {
      AG: t('state_mx_ag', 'Aguascalientes'),
      BC: t('state_mx_bc', 'Baja California Norte'),
      BS: t('state_mx_bs', 'Baja California Sur'),
      CH: t('state_mx_ch', 'Chihuahua'),
      CL: t('state_mx_cl', 'Colima'),
      CM: t('state_mx_cm', 'Campeche'),
      CO: t('state_mx_co', 'Coahuila'),
      CS: t('state_mx_cs', 'Chiapas'),
      DF: t('state_mx_df', 'Distrito Federal'),
      DG: t('state_mx_dg', 'Durango'),
      GR: t('state_mx_gr', 'Guerrero'),
      GT: t('state_mx_gt', 'Guanajuato'),
      HG: t('state_mx_hg', 'Hidalgo'),
      JA: t('state_mx_ja', 'Jalisco'),
      MI: t('state_mx_mi', 'Michoacan'),
      MO: t('state_mx_mo', 'Morelos'),
      MX: t('state_mx_mx', 'Estado de Mexico'),
      NA: t('state_mx_na', 'Nayarit'),
      NL: t('state_mx_nl', 'Nuevo Leon'),
      OA: t('state_mx_oa', 'Oaxaca'),
      PU: t('state_mx_pu', 'Puebla'),
      QR: t('state_mx_qr', 'Quintana Roo'),
      QT: t('state_mx_qt', 'Queretaro'),
      SI: t('state_mx_si', 'Sinaloa'),
      SL: t('state_mx_sl', 'San Luis Potosi'),
      SO: t('state_mx_so', 'Sonora'),
      TB: t('state_mx_tb', 'Tabasco'),
      TL: t('state_mx_tl', 'Tlaxcala'),
      TM: t('state_mx_tm', 'Tamaulipas'),
      VC: t('state_mx_vc', 'Veracruz'),
      YU: t('state_mx_yu', 'Yucatan'),
      ZA: t('state_mx_za', 'Zacatecas')
    },
    US: {
      AA: t('state_us_aa', 'Armed Forces - Americas'),
      AE: t('state_us_ae', 'Armed Forces - Europe'),
      AK: t('state_us_ak', 'Alaska'),
      AL: t('state_us_al', 'Alabama'),
      AP: t('state_us_ap', 'Armed Forces - Pacific'),
      AR: t('state_us_ar', 'Arkansas'),
      AZ: t('state_us_az', 'Arizona'),
      CA: t('state_us_ca', 'California'),
      CO: t('state_us_co', 'Colorado'),
      CT: t('state_us_ct', 'Connecticut'),
      DC: t('state_us_dc', 'District of Columbia'),
      DE: t('state_us_de', 'Delaware'),
      FL: t('state_us_fl', 'Florida'),
      GA: t('state_us_ga', 'Georgia'),
      HI: t('state_us_hi', 'Hawaii'),
      IA: t('state_us_ia', 'Iowa'),
      ID: t('state_us_id', 'Idaho'),
      IL: t('state_us_il', 'Illinois'),
      IN: t('state_us_in', 'Indiana'),
      KS: t('state_us_ks', 'Kansas'),
      KY: t('state_us_ky', 'Kentucky'),
      LA: t('state_us_la', 'Louisiana'),
      MA: t('state_us_ma', 'Massachusetts'),
      MD: t('state_us_md', 'Maryland'),
      ME: t('state_us_me', 'Maine'),
      MI: t('state_us_mi', 'Michigan'),
      MN: t('state_us_mn', 'Minnesota'),
      MO: t('state_us_mo', 'Missouri'),
      MS: t('state_us_ms', 'Mississippi'),
      MT: t('state_us_mt', 'Montana'),
      NC: t('state_us_nc', 'North Carolina'),
      ND: t('state_us_nd', 'North Dakota'),
      NE: t('state_us_ne', 'Nebraska'),
      NH: t('state_us_nh', 'New Hampshire'),
      NJ: t('state_us_nj', 'New Jersey'),
      NM: t('state_us_nm', 'New Mexico'),
      NV: t('state_us_nv', 'Nevada'),
      NY: t('state_us_ny', 'New York'),
      OH: t('state_us_oh', 'Ohio'),
      OK: t('state_us_ok', 'Oklahoma'),
      OR: t('state_us_or', 'Oregon'),
      PA: t('state_us_pa', 'Pennsylvania'),
      PR: t('state_us_pr', 'Puerto Rico'),
      RI: t('state_us_ri', 'Rhode Island'),
      SC: t('state_us_sc', 'South Carolina'),
      SD: t('state_us_sd', 'South Dakota'),
      TN: t('state_us_tn', 'Tennessee'),
      TX: t('state_us_tx', 'Texas'),
      UT: t('state_us_ut', 'Utah'),
      VA: t('state_us_va', 'Virginia'),
      VT: t('state_us_vt', 'Vermont'),
      WA: t('state_us_wa', 'Washington'),
      WI: t('state_us_wi', 'Wisconsin'),
      WV: t('state_us_wv', 'West Virginia'),
      WY: t('state_us_wy', 'Wyoming')
    }
  } as {
    [key:string]: {
      [key:string]: string
    }
  }
}
